module.exports = new __parcel__URL__("ai-premium-upsell-darkmode.090d0954.svg").toString();